import React from 'react';

export default ({ loading = false, color }) => (loading ? <span className="loading-dots" style={{backgroundColor: color}}/> : null);



// WEBPACK FOOTER //
// ./src/components/LoadingDots.js